import{D as t}from"./custom-element-CDWT-yC_.js";function e(e,o=e,r=t){return e?o:r}export{e as c};
//# sourceMappingURL=cond-Cuc_PMkN.js.map
